import AbstractDataAttributeBehaviour from "./abstract-data-attribute-behaviour";

export default class TogglePasswordBehavior extends AbstractDataAttributeBehaviour {
    attrSelectors = {
        container: 'data-toggle-password-field',
    };

    getContainerSelector()
    {
        return '[' + this.attrSelectors.container + ']';
    }

    initContainer(container)
    {
        container.addEventListener('click', (event) => {
            event.preventDefault();

            let input = document.getElementById( container.getAttribute(this.attrSelectors.container) )
            if(input.getAttribute('type') === 'password') {
                input.setAttribute('type','text');
                container.setAttribute('class','fa fa-eye-slash');
            } else {
                input.setAttribute('type','password');
                container.setAttribute('class', 'fa fa-eye');
            }
        });
    }
}
